export const REVIEW_LIST_LIMIT = 36;
export const PHONE_TYPE_ID = 29;
